import { motion } from "framer-motion";
import Image from "next/legacy/image";
import Link from "next/link";
import React, { memo, useState } from "react";

import NewCarousel, {
  CardVariants,
} from "@/components/brandRefresh/new-carousel";

const CreditCarousel = memo(({ deviceType, streams }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <NewCarousel
      activeIndex={activeIndex}
      setActiveIndex={setActiveIndex}
      streams={streams}
      autoPlaySpeed={10 * 1000}
      className="gap-24 md:gap-0"
      reverseDotColor
      dotsClass="4xl:mt-36"
      disableTimer={deviceType === "mobile"}
    >
      <div className="flex justify-center md:w-[884px] md:h-[592px] sm:w-[600px] 4xl:h-[664px] w-auto h-[480px] py-[52px] text-onmoText">
        {streams.map((customer, index) => {
          const isActive = activeIndex === index;
          const isNext =
            activeIndex === index - 1 ||
            (index === 0 && activeIndex === streams.length - 1);
          const isPrev =
            activeIndex === index + 1 ||
            (index === streams.length - 1 && activeIndex === 0);
          return (
            <React.Fragment key={customer.id}>
              <motion.div
                className={`carousel-card !items-start md:w-[448px] 4xl:w-[600px] 4xl:h-[664px] sm:w-[350px] w-[286px] md:h-[492px] h-[420px] rounded-[20px] bg-onmoPurple-200 relative ${
                  isPrev ? "relative" : isNext ? "relative" : "absolute"
                }`}
                variants={CardVariants(deviceType)}
                initial="hidden"
                animate={
                  isActive
                    ? "active"
                    : isPrev
                    ? "prev"
                    : isNext
                    ? "next"
                    : "prev"
                }
                transition={{
                  type: "spring",
                  stiffness: 500,
                  damping: 50,
                }}
                style={{
                  position: "absolute",
                  display: "flex",
                  visibility:
                    isActive || isNext || isPrev ? "visible" : "hidden",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  if (isNext) {
                    let nextIndex = activeIndex + 1;
                    if (activeIndex === streams.length - 1) {
                      nextIndex = 0;
                    }
                    setActiveIndex(nextIndex);
                  } else if (isPrev) {
                    let prevIndex = activeIndex - 1;
                    if (activeIndex <= 0) {
                      prevIndex = streams.length - 1;
                    }
                    setActiveIndex(prevIndex);
                  }
                }}
              >
                <div
                  className={`md:px-[32px] px-4 md:py-[52px] py-8 text-left  ${
                    isActive ? "" : "hidden"
                  }`}
                >
                  <div className="hidden 4xl:block">
                    <Image
                      alt="Onmo credit card"
                      src={customer.img}
                      width="200"
                      height="200"
                      layout="fixed"
                      loading="lazy"
                    />
                  </div>
                  <div className="hidden md:block 4xl:hidden">
                    <Image
                      alt="Onmo credit card"
                      src={customer.img}
                      width="150"
                      height="150"
                      layout="fixed"
                      loading="lazy"
                    />
                  </div>
                  <div className="md:hidden">
                    <Image
                      alt="Onmo credit card"
                      src={customer.img}
                      width="100"
                      height="100"
                      layout="fixed"
                      loading="lazy"
                    />
                  </div>
                  <div className=" mb-4">
                    <h2 className="text-xl md:text-2xl font-medium 4xl:text-size-5 4xl:leading-52">
                      {customer.title}
                    </h2>
                  </div>

                  <p className="mb-10 text-sm md:text-base 4xl:text-size-4 4xl:leading-8">
                    {customer?.desc || "-"}
                  </p>
                  <Link
                    href={customer.href}
                    passHref
                    className="text-base flex justify-start gap-3 text-onmoPrimary font-medium mt-auto 4xl:text-size-4"
                    target="_blank"
                  >
                    View all FAQ&apos;s
                    <Image
                      width={20}
                      height={11}
                      src={"/images/rightArrow.svg"}
                      alt="Arrow"
                    />
                  </Link>
                </div>
              </motion.div>
            </React.Fragment>
          );
        })}
      </div>
    </NewCarousel>
  );
});

CreditCarousel.displayName = "CreditCarousel";

export default CreditCarousel;
